// extracted by mini-css-extract-plugin
export default {"header":"families-list_header__Lr3GP","buttonWrapper":"families-list_buttonWrapper__iYMEz","list":"families-list_list__cOi8V","listItem":"families-list_listItem__EJjXG"};